import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "./auth-services";

export const hrBaseApi = createApi({
  reducerPath: "hrApi",

  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accesstoken");

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");

      return headers;
    },
  }),

  tagTypes: [
    "PendingApprovals",
    "TodayDashboard",
    "TotalEmployees",
    "EmployeeCheckinSummary",
    "LateCheckinList",
    "PendingLeaveRequests",
    "LeaveUsageTrend",
    "EmployeeCheckinCRUD",
    "DepartmentWiseAttrition",
    "EmployeeOrganization",
    "EmployeeList",
    "DeviceConfigurationList",
    "EmployeeCheckinList",
    "EmployeeAbsentList",
    "PayrollAttendanceList",
    "CheckinStatus",
    "EmployeeCheckin",
    "TimesheetList",
    "LeaveOpeningBalance",
    "LeaveCancellation",
    "LeaveTypeList",
    "PayCalendar",
    "EmployeeProvidentFund",
    "EmployeeESI",
    "SlabConfiguration",
  ],

  endpoints: () => ({}),
});